import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { TextArea } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";

const ChitRequestRejectDialog = ({
  open,
  loading,
  rejectionReason,
  onReasonChange,
  onClose,
  onReject,
}) => {
  if (!open) return null;

  return (
    <Dialog
      title="Reject Chit Request"
      onClose={onClose}
      width={450}
    >
      <div className="p-3">
        <Label className="label mb-2 d-block">Rejection Reason</Label>
        <TextArea
          className="w-100"
          rows={5}
          value={rejectionReason}
          onChange={onReasonChange}
          placeholder="Enter reason for rejection..."
          style={{
            height: "80px",
            resize: "none",
            maxWidth: "100%",
            border:
              !rejectionReason.trim() && rejectionReason !== ""
                ? "1px solid red"
                : undefined,
          }}
        />
      </div>
      <div className="d-flex justify-content-end w-100 gap-2 dialog-footer">
        <Button
          className="common-btn bgBtnSecondary"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <SubmitButton
          className="common-btn me-3"
          onClick={onReject}
          disabled={loading || !rejectionReason.trim()}
          isLoading={loading}
        >
          {loading ? "Rejecting..." : "Reject"}
        </SubmitButton>
      </div>
    </Dialog>
  );
};

export default ChitRequestRejectDialog;
